import { render, staticRenderFns } from "./table-diretrizes.vue?vue&type=template&id=7b8a6f15&scoped=true&"
import script from "./table-diretrizes.vue?vue&type=script&lang=js&"
export * from "./table-diretrizes.vue?vue&type=script&lang=js&"
import style0 from "./table-diretrizes.vue?vue&type=style&index=0&id=7b8a6f15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8a6f15",
  null
  
)

export default component.exports